/* __next_internal_client_entry_do_not_use__ VisuallyHidden auto */ import * as RadixVisuallyHidden from "@radix-ui/react-visually-hidden";
export const VisuallyHidden = RadixVisuallyHidden.Root;
